/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neural_CoreInputs */

const en_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neural Core`)
};

const es_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Núcleo neuronal`)
};

const fr_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cœur neural`)
};

const de_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuraler Kern`)
};

const ja_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ニューラルコア`)
};

const zh_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`神经元核心`)
};

const ar_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النواة العصبية`)
};

const id_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inti Neural`)
};

const it_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nucleo Neurale`)
};

const ru_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нейроядро`)
};

const pt_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Núcleo Neural`)
};

const ko_neural_core = /** @type {(inputs: Neural_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뉴럴 코어 (Neural Core)`)
};

/**
* | output |
* | --- |
* | "Neural Core" |
*
* @param {Neural_CoreInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const neural_core = /** @type {((inputs?: Neural_CoreInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neural_CoreInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neural_core(inputs)
	if (locale === "es") return es_neural_core(inputs)
	if (locale === "fr") return fr_neural_core(inputs)
	if (locale === "de") return de_neural_core(inputs)
	if (locale === "ja") return ja_neural_core(inputs)
	if (locale === "zh") return zh_neural_core(inputs)
	if (locale === "ar") return ar_neural_core(inputs)
	if (locale === "id") return id_neural_core(inputs)
	if (locale === "it") return it_neural_core(inputs)
	if (locale === "ru") return ru_neural_core(inputs)
	if (locale === "pt") return pt_neural_core(inputs)
	return ko_neural_core(inputs)
});